export function useValueWithSuspense<T>(value: T | undefined | null): T {
  if (!value) {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw new Promise((resolve) => {
      requestAnimationFrame(() => resolve(undefined));
    });
  }

  return value;
}
